import {useAppSelector} from "@/lib/hooks";

// AC-819: GeoIP country (populated into the store from the x-vercel-ip-country
// header) for the per-GEO lobby endpoints. The 'unknown' sentinel (local dev,
// header absent) must never reach the backend — undefined = global lobby.
export const useLobbyCountry = (): string | undefined => {
    const country = useAppSelector(state => state.auth.country);
    return country && country !== 'unknown' && /^[A-Za-z]{2}$/.test(country)
        ? country.toUpperCase()
        : undefined;
};
